import { createContext } from 'react'

interface ContextState {
  showHeaderFilter: boolean
}

const defaultState: ContextState = {
  showHeaderFilter: true,
}

export const ReadGridHeaderFilters = createContext(defaultState)
